import { MediaItem } from 'Interfaces/general.interface';

type Props = {
    video: MediaItem;
    videoClass: string;
    wrapperDivClass?: string;
    withControls: boolean;
    autoPlay: boolean;

    // Props are not being used
    cancelLoop?: Boolean;
    onVideoEnded?: any;
}


const ComponentVideo: React.FC<Props> = ({ autoPlay, video, videoClass, withControls, wrapperDivClass = '' }) => {

    return (
        <div className={wrapperDivClass}>

            {
                video.url && withControls ?
                    <video className={`${videoClass}`} muted={autoPlay ? true : false} autoPlay={autoPlay} loop controls playsInline webkit-playsinline='true'>
                        <source src={`${video.url}#t=0.001`} type='video/mp4' />
                    </video>
                :

                    <video className={`${videoClass} `} muted autoPlay loop playsInline webkit-playsinline='true'>
                        <source src={`${video.url}#t=0.001`} type='video/mp4' />
                    </video>
            }

        </div>
    );

}

export default ComponentVideo;
